export default "__VITE_ASSET__86318a42__"